import { useId } from "react";

/*
 * Ornamental Pattachitra-style border band — repeating diamond motif
 * in vermillion, marigold and cream over navy.
 */
const FolkBorder = ({ className = "" }) => {
  const id = useId().replace(/[^a-zA-Z0-9]/g, "");
  return (
    <div className={`w-full ${className}`} data-testid="folk-border" aria-hidden="true">
      <svg className="block w-full" height="26" width="100%" preserveAspectRatio="none">
        <defs>
          <pattern id={`folk-${id}`} width="48" height="26" patternUnits="userSpaceOnUse">
            <rect width="48" height="26" fill="#14355c" />
            <path d="M12 13 L24 3 L36 13 L24 23 Z" fill="#cf4b26" />
            <path d="M18 13 L24 8 L30 13 L24 18 Z" fill="#f0b52f" />
            <path d="M-12 13 L-6 8 L0 13 L-6 18 Z" fill="#f0b52f" />
            <path d="M-6 13 L0 8 L6 13 L0 18 Z" fill="#f0b52f" />
            <path d="M36 13 L42 8 L48 13 L42 18 Z" fill="#f0b52f" />
            <path d="M42 13 L48 8 L54 13 L48 18 Z" fill="#f0b52f" />
            <circle cx="24" cy="2" r="1.5" fill="#f7efdc" />
            <circle cx="24" cy="24" r="1.5" fill="#f7efdc" />
            <circle cx="0" cy="2" r="1.5" fill="#f7efdc" />
            <circle cx="0" cy="24" r="1.5" fill="#f7efdc" />
          </pattern>
        </defs>
        <rect width="100%" height="26" fill={`url(#folk-${id})`} />
      </svg>
      <div className="h-[3px] bg-verm" />
    </div>
  );
};

export default FolkBorder;
